import FlatpickrImport from 'react-flatpickr';

// Vite's dev-server dependency pre-bundling sometimes binds the react-flatpickr import to the
// whole `{ default: Component }` exports object (UMD build) instead of the component —
// "Element type is invalid... got: object". Unwrap defensively; prod's Rollup build is unaffected.
const Flatpickr = (FlatpickrImport as unknown as { default?: typeof FlatpickrImport }).default ?? FlatpickrImport;

export default Flatpickr;
